import ReactDataGrid from '@inovua/reactdatagrid-community';
import Modal from '@components/modal/Modal';
import styles from './CompletedLessonModal.module.scss';
import CloseIcon from 'src/assets/icons/close.svg?react';
import OverflowTooltip from '@src/components/overflowTooltip/OverflowTooltip';
import { shortenYearFormatDate } from '@src/utils/time';

type Props = {
  open: boolean
  onClose: () => void
  completedLessons: any[]
  userName?: string
  isAussie: boolean;
}

const columns = [
  {
    name: 'grade',
    header: (<div className={styles.headercol}>Grade</div>),
    defaultFlex: 1.2,
    textAlign: 'start' as any,
    sortable: false,
    resizable: false,
    headerProps: { style: { backgroundColor: '#E7E7E7', color: '#4A4A4A' } },
    render: ({ value }) => {
      return <OverflowTooltip text={(value ?? '').replace(' Program', '').replace(/[[\]\\"]/g, "").replace(/,/g, ", ")} width={130}/>
    },
    style: {
      paddingLeft: '20px',
    }
  },
  {
    name: 'lessonName',
    header: (<div className={styles.headercol}>Lesson Name</div>),
    textAlign: 'start' as any,
    defaultFlex: 3,
    sortable: false,
    resizable: false,
    headerProps: { style: { backgroundColor: '#E7E7E7', color: '#4A4A4A' } },
    style: {
      paddingLeft: '20px',
    },
    render: ({ value }) => {
      return <div style={{fontSize: 14}}>{value}</div>
    }
  },
  {
    name: 'lessonType',
    header: (<div className={styles.headercol}>Lesson Type</div>),
    textAlign: 'start' as any,
    defaultFlex: 2,
    sortable: false,
    resizable: false,
    headerProps: { style: { backgroundColor: '#E7E7E7', color: '#4A4A4A' } },
    style: {
      paddingLeft: '20px',
    },
    render: ({ value }) => {
      return <div style={{fontSize: 14}}>{value}</div>
    }
  },
  {
    name: 'completedAt',
    header: (<div className={styles.headercol}>Date Completed</div>),
    textAlign: 'start' as any,
    defaultFlex: 1.4,
    sortable: false,
    resizable: false,
    headerProps: { style: { backgroundColor: '#E7E7E7', color: '#4A4A4A' } },
    style: {
      paddingLeft: '20px',
    },
    render: ({ value }) => {
      return <div style={{fontSize: 14}}>{shortenYearFormatDate(value)}</div>
    }
  },
]


const auColumns = [
  {
    name: 'grade',
    header: (<div className={styles.headercol}>Grade</div>),
    defaultFlex: 1.5,
    textAlign: 'start' as any,
    sortable: false,
    resizable: false,
    headerProps: { style: { backgroundColor: '#E7E7E7', color: '#4A4A4A' } },
    render: ({ value }) => {
      return <OverflowTooltip text={(value ?? '').replace(' Program', '').replace(/[[\]\\"]/g, "").replace(/,/g, ", ")} width={116} />
    },
    style: {
      paddingLeft: '20px',
    }
  },
  {
    name: 'lessonName',
    header: (<div className={styles.headercol}>Lesson Name</div>),
    textAlign: 'start' as any,
    defaultFlex: 3,
    sortable: false,
    resizable: false,
    headerProps: { style: { backgroundColor: '#E7E7E7', color: '#4A4A4A' } },
    style: {
      paddingLeft: '20px',
    },
    render: ({ value }) => {
      return <div className={styles.lessonName} style={{fontSize: 14}}>{value}</div>
    }
  },
  {
    name: 'unitName',
    header: (<div className={styles.headercol}>Unit Name</div>),
    textAlign: 'start' as any,
    defaultFlex: 3,
    sortable: false,
    resizable: false,
    headerProps: { style: { backgroundColor: '#E7E7E7', color: '#4A4A4A' } },
    style: {
      paddingLeft: '20px',
    },
    render: ({ value }) => {
      return <div className={styles.unitName} style={{fontSize: 14}}>{value ? value : 'Standalone Lesson'}</div>
    }
  },
  {
    name: 'lessonType',
    header: (<div className={styles.headercol}>Lesson Type</div>),
    textAlign: 'start' as any,
    defaultFlex: 2,
    sortable: false,
    resizable: false,
    headerProps: { style: { backgroundColor: '#E7E7E7', color: '#4A4A4A' } },
    style: {
      paddingLeft: '20px',
    },
    render: ({ value }) => {
      return <div style={{fontSize: 14}}>{value}</div>
    }
  },
  {
    name: 'completedAt',
    header: (<div className={styles.headercol}>Date Completed</div>),
    textAlign: 'start' as any,
    defaultFlex: 1.4,
    sortable: false,
    resizable: false,
    headerProps: { style: { backgroundColor: '#E7E7E7', color: '#4A4A4A' } },
    style: {
      paddingLeft: '20px',
    },
    render: ({ value }) => {
      return <div style={{fontSize: 14}}>{shortenYearFormatDate(value)}</div>
    }
  },
]

function CompletedLessonModal({open, userName, onClose, completedLessons, isAussie}: Props) {
  return (
    <Modal open={!!open} onClose={onClose} closeButton={false} className={styles.wrapper}>
      <div className={styles.mainView}>
        <button onClick={onClose} className={styles.closeWrapper}>
          <CloseIcon className={styles.closeIcon} />
        </button>
        <div className={styles.title}>Completed Lessons: {userName}</div>
          <div className={styles.content}>
            {completedLessons.length && (
              <ReactDataGrid
                idProperty="id"
                columns={isAussie ? auColumns : columns}
                headerHeight={60}
                rowHeight={46}
                dataSource={completedLessons.map((elem, index) => ({ id: `el_${index}`, ...elem }))}
                style={{minHeight: 400}}
                pagination={false}
                showColumnMenuTool={false}
                enableSelection={false}
                checkboxColumn={false}
              />
            )}
          </div>
      </div>
    </Modal>
  )
}

export default CompletedLessonModal;
